/** Collapse 2+ whitespace runs to a single space and trim ends. */
export function collapseRepeatedSpaces(value: string): string {
  return String(value ?? "").replace(/\s{2,}/g, " ").trim()
}
